import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MainModuleRoutingModule } from './main-module-routing.module';
import { HomeComponent } from './home/home.component';
import { ElementsModule } from 'src/app/shared/elements/elements.module';
import { SidenavComponent } from './sidenav/sidenav.component';
import { AboutComponent } from './about/about.component';
import { TermsComponent } from './terms/terms.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { TestimonialComponent } from './testimonial/testimonial.component';
import { ServiceDetailComponent } from './service-detail/service-detail.component';
import { ServiceComponent } from './service/service.component';
import { ContactComponent } from './contact/contact.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiesPolicyComponent } from './cookies-policy/cookies-policy.component';
import { TabsComponent } from './tabs/tabs.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ElastomerComponent } from './capability/elastomer/elastomer.component';
import { LucideAngularModule, icons } from 'lucide-angular';
import { PlasticPartProcessingComponent } from './capability/plastic_part_processing/plastic-part-processing.component';
import { SinteredMetalPartComponent } from './capability/sintered_metal_parts/sintered-metal-part.component';
import { WireWiringHarnessComponent } from './capability/wires_wiring_harness/wire-wiring-harness.component';
import { IndirectSolutionsComponent } from './capability/indirect-solutions/indirect-solutions.component';
import { RawMaterialComponent } from './capability/raw-material/raw-material.component';
import { CoatingsComponent } from './capability/coatings/coatings.component';
import { MetalMachiningComponent } from './capability/metal-machining/metal-machining.component';
import { DieCastingComponent } from './capability/die-casting/die-casting.component';
import { MetalStampingComponent } from './capability/metal-stamping/metal-stamping.component';
import { SurfaceFinishingComponent } from './capability/surface-finishing/surface-finishing.component';
import { PaintingEquipmentComponent } from './capability/painting-equipment/painting-equipment.component';
import { MaterialHandlingComponent } from './capability/material-handling/material-handling.component';
import { InjectionMouldingMachineComponent } from './capability/injection-moulding-machine/injection-moulding-machine.component';
import { AuxiliaryEquipmentComponent } from './capability/auxiliary-equipment/auxiliary-equipment.component';
import { MouldingToolsManufacturingComponent } from './capability/moulding-tools-manufacturing/moulding-tools-manufacturing.component';
import { VideoLaunchComponent } from './video-launch/video-launch.component';
import { RobotProcessAutomationComponent } from './capability/robot-process-automation/robot-process-automation.component';
import { ModlingMachineEnhancementComponent } from './capability/modling-machine-enhancement/modling-machine-enhancement.component';
import { CareerComponent } from './career/career.component';
import { CareerDetailComponent } from './career-detail/career-detail.component';
import { TeamsComponent } from './teams/teams.component';
import { PolicyComponent } from './policy/policy.component';

@NgModule({
  declarations: [
    HomeComponent,
    SidenavComponent,
    AboutComponent,
    TermsComponent,
    DisclaimerComponent,
    TestimonialComponent,
    ServiceDetailComponent,
    ServiceComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    CookiesPolicyComponent,
    TabsComponent,
    ElastomerComponent,
    PlasticPartProcessingComponent,
    SinteredMetalPartComponent,
    WireWiringHarnessComponent,
    IndirectSolutionsComponent,
    RawMaterialComponent,
    CoatingsComponent,
    MetalMachiningComponent,
    DieCastingComponent,
    MetalStampingComponent,
    SurfaceFinishingComponent,
    PaintingEquipmentComponent,
    MaterialHandlingComponent,
    InjectionMouldingMachineComponent,
    AuxiliaryEquipmentComponent,
    MouldingToolsManufacturingComponent,
    VideoLaunchComponent,
    RobotProcessAutomationComponent,
    ModlingMachineEnhancementComponent,
    CareerComponent,
    CareerDetailComponent,
    TeamsComponent,
    PolicyComponent
  ],
  imports: [
    CommonModule,
    MainModuleRoutingModule,
    MaterialModule,
    ElementsModule,
    SlickCarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    LucideAngularModule.pick(icons)
  ],
})
export class MainModuleModule { }
